<template>
    <div class="animated fadeIn">
        <BaseInventory
            categoryId="7"
            categoryName="Motor"
            categorySectionIcon="fa-wrench"
            :useSearch1="true"
            search1Title="Spek"
        />
    </div>
</template>

<script>
import BaseInventory from './base/BaseInventory'

export default {
    name: 'motor',
    components: { BaseInventory }
}
</script>
